import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExerciseStatus } from "../../constants/exercises";
import { endExercise, moveNext, quitExercise, startExercise, SelectedLevelAndGender, Gender } from "./ntfHelper";


export interface NtfExercises {
  count: number
  levels: number[]
  cardBack: string
  minLevelGenderSelection: number
}

export interface NtfUserScore {
  level: number
  gender?: Gender
  finished?: boolean
  start: number
  end?: number
  attempts?: number
}

export interface Card {
  name: string
  card: string
}

export interface NtfState {
  status: ExerciseStatus
  id?: string
  exercises?: NtfExercises
  cards?: Card[]
  userScores: NtfUserScore[]
  startTime?: number
  endTime?: number
}

export interface NtfResult {
  finished: boolean
  attempts: number
}

const initialState: NtfState = {
  status: 'start',
  userScores: []
}

interface NtfExercisesPayload {
  id: string
  exercises: NtfExercises
}

export const ntfSlice = createSlice({
  name: 'nameTheFace',
  initialState,
  reducers: {
    installExercises: (state, action: PayloadAction<NtfExercisesPayload>) => {
      state.exercises = action.payload.exercises
      state.id = action.payload.id
    },
    next: (state) => {
      moveNext(state)  
    },
    start: (state, action: PayloadAction<SelectedLevelAndGender>) => {
      const { level, gender } = action.payload
      startExercise(level, gender, state)
      moveNext(state, true)
    },
    end: (state, action: PayloadAction<NtfResult>) => {
      const { attempts, finished } = action.payload
      endExercise(finished, attempts, state)
      moveNext(state)
    },
    quit: (state) => {
      quitExercise(state)
    },
    reset: () => {
      return initialState
    },
    loadCards: (state, action: PayloadAction<SelectedLevelAndGender>) => {
      state.cards = []
    },
    installCards: (state, action: PayloadAction<Card[]>) => {
      state.cards = action.payload
    },
  }
})

export const requestQuit = createAction<string|undefined>('nameTheFace/requestQuit')

export const { installExercises, next, start, end, quit, reset, loadCards, installCards } = ntfSlice.actions

export default ntfSlice.reducer
